import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App'; // Import your main App component
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from 'react-router-dom'; // Import Router
import { ThemeProvider, createTheme } from '@mui/material/styles'; // Import MUI ThemeProvider
import Footer from './footer';
import Background from './component/backgroundlayout'; // Import the Background component

const theme = createTheme();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <Router> {/* Ensure that Router wraps your App */}
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
          <Background /> {/* Optionally include your Background component */}
          <div style={{ flex: '1' }}>
            <App /> {/* Your App component, which contains the Routes */}
          </div>
          <Footer /> {/* Footer will always be at the bottom */}
        </div>
      </Router>
    </ThemeProvider>
  </React.StrictMode>
);

// Measure performance if needed
reportWebVitals();
